import {UnitType} from "../api/Constants";

export const GRAMS_PER_LB = 450
export const GRAMS_PER_LB_454 = 454

export const fixedToDisplayUnit = (value, type) => {
    switch (type) {
        case UnitType.Gram:
            return value / 10;
        case UnitType.Lbs:
            return value / 100;
        case UnitType.Liter:
            return value / 1000;
        default:
            return value;
    }
}

export const displayToFixedUnit = (value, type) => {
    switch (type) {
        case UnitType.Gram:
            return Math.floor(value * 10);
        case UnitType.Lbs:
            return Math.floor(value * 100);
        case UnitType.Liter:
            return Math.floor(value * 1000);
        default:
            return value;
    }
}

export const getUnitPrecision = (unit) => {
    switch (unit) {
        case UnitType.Gram:
        case UnitType.Hour:
            return 1;
        case UnitType.Lbs:
            return 2;
        case UnitType.Liter:
            return 3;
        default:
            return 0;
    }
}

export const clampToCents = (floatCurrency) => {
    const fixed = floatCurrency.toFixed(2);
    return parseFloat(fixed);
}

export const gramsToLbs = (numGrams) => {
    const val = (numGrams / GRAMS_PER_LB);

    return parseFloat(val.toFixed(2));
}

export const lbsToGrams = (numLbs) => {
    const val = numLbs * GRAMS_PER_LB;

    return Math.floor(val);
}